import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/portfolio/Header";
import Hero from "@/components/portfolio/Hero";
import About from "@/components/portfolio/About";
import Experience from "@/components/portfolio/Experience";
import Projects from "@/components/portfolio/Projects";
import Expertise from "@/components/portfolio/Expertise";
import Education from "@/components/portfolio/Education";
import Contact from "@/components/portfolio/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain bg-paper text-ink antialiased" data-testid="portfolio-app">
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Expertise />
        <Education />
      </main>
      <Contact />
    </div>
  );
}

export default App;
